import addLamp from "../../Components/ThreeModules/lamp"

const outsideObjs = () => {
  // addLamp({
  //   position: { x: 0, y: 400, z: 1500 },
  //   rotation: { x: 0, y: 0, z: 0 },
  //   scale: { x: 500, y: 500, z: 500 },
  // })
}

export default outsideObjs
